import { useEffect } from 'react';

import { LogoTriangle } from '@stratumn/atomic';

import qs from 'query-string';
import type { RouteComponentProps } from 'react-router-dom';

import { Button } from '@/shadcn/button';

import { LogoStratumn } from '@/components/ui/customIcons/logoStratumn';
import { env } from '@/constant/env';
import { TestId } from '@/types/testId';
import { deepGet } from '@/utils';

export const Login = (props: RouteComponentProps) => {
  useEffect(() => {
    // clear the cookie when we try loggin in
    // biome-ignore lint/suspicious/noDocumentCookie: we need to clear the cookie to avoid issues with the login
    document.cookie =
      'local_stratumn_account=; expires=Thu, 01 Jan 1970 00:00:01 GMT;stratumn_account=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    document.title = 'Log in - Trace';
  }, []);

  const getRedirectUri = () => {
    const redirect = deepGet(props, 'location.state.redirect');
    return `${window.location.origin}${redirect || ''}`;
  };

  const onLoginClick = () => {
    const params = qs.stringify({
      clientId: env.VITE_CLIENT_ID,
      redirectUri: getRedirectUri()
    });
    window.location.replace(`${env.VITE_ACCOUNT_URL}/login?${params}`);
  };

  return (
    <>
      <div
        className="-z-1 fixed inset-0 h-full bg-[url('/src/assets/IndigoTrace_Map.svg')] bg-center bg-cover bg-primary-dark bg-no-repeat dark:bg-background dark:brightness-50"
        role="none"
      />
      <div className="flex min-h-screen flex-col items-center justify-between">
        <div className="flex flex-col items-center">
          <div className="mt-[60px] flex h-9 items-center justify-center overflow-hidden">
            <LogoStratumn axis="y" className="h-full" fillWhite />
          </div>
          <div className="mt-11 font-semibold text-primary-foreground">
            The new backbone to business collaboration
          </div>
          <div className="mt-5 flex w-full max-w-[400px] flex-col items-center rounded-md border border-border bg-card px-[60px] py-[20px]">
            <div className="mb-5 font-semibold">
              Sign in with Stratumn Account
            </div>
            <Button
              aria-label="Click to login"
              data-testid={TestId.Login.Button}
              onClick={onLoginClick}
            >
              <LogoTriangle fillWhite size={16} />
              <span className="pt-[3px]">Sign in</span>
            </Button>
          </div>
        </div>
        <div
          aria-label="Built by Stratumn"
          className="mb-2.5 text-center text-primary-foreground text-xs"
        >
          Built by{' '}
          <a
            className="text-inherit hover:underline"
            href="https://stratumn.com/"
            rel="noopener noreferrer"
            target="_blank"
          >
            Stratumn
          </a>
        </div>
      </div>
    </>
  );
};
